import React, { useEffect } from 'react';
import { Box, Button, colors, Grid, Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import Alert from '../components/Alert/Alert';
import { setVehicle } from '../redux/slices/vehicle';
import { RootState } from '../redux/store';
import { stages } from '../utils/constants';
import StepperVertical from '../components/Stepper/StepperVertical';
import VehicleVerticalTabs from '../modules/VehicleVerticalTabs';
import Page from '../components/Page/Page';
import InfoHeader from '../modules/InfoHeader';
import Stepper from '../components/Stepper/Stepper';
import ActionsTabs from '../modules/CustomerDetailsSection/ActionsTabs';
import { getVehicle } from '../services/vehicles';

const content = (
  <>
    <Typography variant="caption" component="div">
      July 10, 2022 - Actual arrival date
    </Typography>
    <Typography variant="caption" component="div">
      July 10, 2022 - Actual arrival date
    </Typography>
  </>
);

const Vehicle = () => {
  // use hooks
  const dispatch = useDispatch();
  const { reservationId } = useParams<{ reservationId: string }>();

  // global states
  const stage = useSelector((state: RootState) => state.vehicle.data.stage);
  const reservationDate = useSelector((state: RootState) => state.vehicle.data.reservationDate);
  const stageUpdatedDate = useSelector((state: RootState) => state.vehicle.data.stageUpdatedDate);

  // constants
  const tabs = [
    {
      id: 'DUE_TODAY',
      title: 'Due Today',
    },
    {
      id: 'UPCOMING',
      title: 'Upcoming Tasks',
    },
    {
      id: 'COMPLETED',
      title: 'Completed Tasks',
    },
  ];

  const stepsVertical = [
    {
      id: '1',
      label: (
        <Typography variant="body2" fontWeight={600}>
          En-route
        </Typography>
      ),
      content,
    },
    {
      id: '2',
      label: (
        <Typography variant="body2" fontWeight={600}>
          In yard
        </Typography>
      ),
      content,
    },
  ];

  // lifecycle hooks
  useEffect(() => {
    if (reservationId) {
      getVehicle(reservationId).then((vehicle) => {
        dispatch(setVehicle(vehicle));
      });
    }
  }, [reservationId, dispatch]);

  return (
    <Page sx={{ backgroundColor: (theme) => theme.palette.grey[100] }}>
      <Box>
        <InfoHeader />
        <Box sx={{ p: 2 }}>
          <Grid container spacing={2}>
            <Grid item sm={12} md={6} lg={4}>
              <VehicleVerticalTabs />
            </Grid>
            <Grid item sm={12} md={6} lg={8}>
              <Paper sx={{ px: 5, py: 2, height: '100%' }}>
                <Stepper
                  activeStep={stages.indexOf(stage)}
                  steps={stages as unknown as string[]}
                  orientation="horizontal"
                  dates={[
                    reservationDate ? moment(reservationDate).format('MMM D, YYYY') : '',
                    stageUpdatedDate && stage === 'Ordered' ? moment(reservationDate).format('MMM D, YYYY') : '',
                  ]}
                />
                {(stage as any) === 'Cancellation' && (
                  <Box pt={2}>
                    <Alert
                      variant="outlined"
                      severity="error"
                      action={
                        <Button color="inherit" size="small">
                          know more
                        </Button>
                      }
                    >
                      This reservation was cancelled
                    </Alert>
                  </Box>
                )}
                <Grid container spacing={2} mt={2}>
                  <Grid item sm={12} md={7} m={0}>
                    <ActionsTabs tabs={tabs} />
                  </Grid>
                  <Grid item md={5}>
                    <Typography variant="body2" fontWeight={700} fontSize={12} color={colors.grey[600]}>
                      ORDERED
                    </Typography>
                    <StepperVertical steps={stepsVertical} activeStep={1} />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Page>
  );
};

export default Vehicle;
